// Tipos para Estratificação de Risco

export enum RiskLevel {
  LOW = 'LOW',
  MODERATE = 'MODERATE',
  HIGH = 'HIGH',
  CRITICAL = 'CRITICAL'
}

export interface RiskFactor {
  code: string;
  description: string;
  category: string;
  weight: number;
}

export interface RiskAssessmentResponse {
  id: string;
  patientId: string;
  patientName: string;
  clinicalScore: number;
  psychosocialScore: number;
  hospitalizationRisk: number;
  erUsageRisk: number;
  overallLevel: RiskLevel;
  factors: RiskFactor[];
  notes?: string;
  assessedByName?: string;
  assessedAt: string;
  validUntil?: string;
  isExpired: boolean;
  createdAt: string;
}

export interface RiskAssessmentListResponse {
  id: string;
  patientId: string;
  patientName: string;
  overallLevel: RiskLevel;
  clinicalScore: number;
  assessedAt: string;
  validUntil?: string;
  isExpired: boolean;
}

export interface CreateRiskAssessmentRequest {
  patientId: string;
  recentHospitalizations?: number;
  recentERVisits?: number;
  livesAlone?: boolean;
  noCaregiver?: boolean;
  lowIncome?: boolean;
  lowEducation?: boolean;
  mentalHealthIssues?: boolean;
  substanceAbuse?: boolean;
  foodInsecurity?: boolean;
  notes?: string;
}

export interface RiskStatistics {
  lowCount: number;
  moderateCount: number;
  highCount: number;
  criticalCount: number;
  totalAssessments: number;
}

// Configurações de exibição
export const RiskLevelConfig: Record<RiskLevel, {
  label: string;
  color: string;
  bgColor: string;
  borderColor: string;
  priority: number;
}> = {
  [RiskLevel.LOW]: {
    label: 'Baixo',
    color: '#16a34a',
    bgColor: '#dcfce7',
    borderColor: '#86efac',
    priority: 1
  },
  [RiskLevel.MODERATE]: {
    label: 'Moderado',
    color: '#ca8a04',
    bgColor: '#fef9c3',
    borderColor: '#fde047',
    priority: 2
  },
  [RiskLevel.HIGH]: {
    label: 'Alto',
    color: '#dc2626',
    bgColor: '#fee2e2',
    borderColor: '#fca5a5',
    priority: 3
  },
  [RiskLevel.CRITICAL]: {
    label: 'Crítico',
    color: '#9333ea',
    bgColor: '#f3e8ff',
    borderColor: '#c4b5fd',
    priority: 4
  }
};

export const RiskFactorCategories: Record<string, string> = {
  AGE: 'Idade',
  CLINICAL: 'Clínico',
  SOCIAL: 'Social',
  BEHAVIORAL: 'Comportamental',
  HOSPITALIZATION: 'Hospitalização'
};
